import { AppNotification } from "components/AppNotifications/AppNotification";
import { AppNotificationsNotificationType } from "components/AppNotifications/AppNotifications/AppNotifications";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import style from "./styles/style.scss";

export interface PromptContainerProps {
    fullsize: boolean;
    type: "recomendations" | "notifications";
    readonly orgId?: string;
    readonly appId?: string;
    readonly notifications?: readonly AppNotificationsNotificationType[];
    readonly faqTotal?: number;
    readonly documentsTotal?: number;
    readonly appIcon?: string;
    readonly appBanner?: string;
    readonly noChatWidgetChannel?: boolean;
    readonly orgIcon?: string;
    readonly numberOfApps?: number;
    readonly numberOfMembers?: number;
}

export const PromptContainer: FC<PromptContainerProps> = (props) => {
    const { fullsize, type, orgId, appId, notifications, faqTotal, documentsTotal, appIcon, appBanner, noChatWidgetChannel, orgIcon, numberOfApps, numberOfMembers=2 } = props;

    return (
        <div className={style.promptContainer} style={fullsize ? { width: "100%" } : {}}>
            <div className={style.promptContainerHeader}>
                {type === "recomendations" ? "Recomendations" : "Notifications & Errors"}
            </div>
            <div className={style.promptContainerInner}>
                {type === "recomendations" && (
                    <>
                        {faqTotal === 0 && <Link to={`/${orgId}/${appId}/answers`}><AppNotification type="recomendation" value="Add FAQs" /></Link>}
                        {documentsTotal === 0 && <Link to={`/${orgId}/${appId}/documents`}><AppNotification type="recomendation" value="Crawl Website" /></Link>}
                        {appIcon === null && <Link to={`/${orgId}/${appId}/app-info`}><AppNotification type="recomendation" value="Add an app icon" /></Link>}
                        {appBanner === null && <Link to={`/${orgId}/${appId}/app-info`}><AppNotification type="recomendation" value="Add app banner" /></Link>}
                        {noChatWidgetChannel && <Link to={`/${orgId}/${appId}/channels`}><AppNotification type="recomendation" value="Add chat widget" /></Link>}
                        {orgIcon === null && <Link to={`/${orgId}/settings`}><AppNotification type="recomendation" value="Add an organization icon" /></Link>}
                        {numberOfApps === 0 && <Link to={`/${orgId}/apps`}><AppNotification type="recomendation" value="Create an app" /></Link>}
                        {numberOfMembers === 1 && <Link to={`/${orgId}/members`}><AppNotification type="recomendation" value="Invite members" /></Link>}
                    </>

                )}
                {type === "notifications" && (
                    <>
                        {notifications?.length > 0 &&
                            notifications.map((n) => (
                                <AppNotification key={n.id} notification={n} type="notification" />
                            ))}
                        {!notifications?.length && <p>Currently there are no notifications</p>}
                    </>
                )}
            </div>
        </div>
    );
};
